import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Modal } from 'antd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { green } from '@material-ui/core/colors';
import 'antd/dist/antd.css';
import Highlighter from 'react-highlight-words';

const { Title } = Typography;

@inject("guideDocumentStore")
@observer
class GuideDocumentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    createClicked = () => this.props.guideDocumentStore.initCreate();
    updateClicked = eventId => this.props.guideDocumentStore.initUpdate(eventId);
    removeClicked = eventId => this.props.guideDocumentStore.deleteGuideDocument(eventId);

    deleteClicked = eventId => {
        Modal.confirm({
            title: 'Remove Guide Document',
            content: 'Are you sure to remove guide document?',
            okText: 'Remove',
            cancelText: 'Cancel',
            onOk: () => this.removeClicked(eventId)
        });
    }

    getColumns = () => {
        return [
            {
                title: 'Title',
                dataIndex: 'title',
                key: 'title',
                width: '50%',
                ...this.getColumnSearchProps('title')
            },
            {
                title: 'Url',
                dataIndex: 'url',
                key: 'url',
                width: '40%',
                ...this.getColumnSearchProps('url')
            },
            {
                title: 'Action',
                dataIndex: 'guideDocumentID',
                key: 'action',
                width: '10%',
                render: guideDocumentID => (
                    <span>
                        <Button onClick={() => this.updateClicked(guideDocumentID)} type="primary" style={{ border: "none", background: "none", boxShadow: "none", margin: 1, padding: 0}}>
                            <EditIcon style={{ color: "#1890ff", fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteClicked(guideDocumentID)} type="primary" style={{ border: "none", background: "none", boxShadow: "none", margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: "#DC004E", fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
            </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
            </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const {
            guideDocuments
        } = this.props.guideDocumentStore;

        return (
            <React.Fragment>
                <Form layout="horizontal">
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3} style={{ width: "80%", position: "relative", float: "left" }}>Guide Document List</Title>
                        <div style={{ textAlign: "right" }}>
                            <button type="button" style={{ border: "none", background: "none", cursor: "pointer" }} onClick={this.createClicked}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Table columns={this.getColumns()} dataSource={guideDocuments} />
                </Form>
            </React.Fragment>
        )
    }
}

export default GuideDocumentList